import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { AcsCredentials } from "./acs.reducer";

export const AcsActions = createActionGroup({
    source: "Acs",
    events: {
        "Fetch acs credentials success": props<AcsCredentials>(),
        "Fetch acs credentials failed": props<{ error: string }>(),
    },
});
